import { Component, OnInit, Input } from '@angular/core';
import { CmsService } from 'src/app/services/api/cms.service';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {

  onClose: any;
  @Input() blockId: any = null;

  constructor(
    public cms: CmsService
  ) { }

  ngOnInit() {
    if(this.blockId){
      this.cms.getBlock(this.blockId, true, false).then(f => {
      });
    }
  }
}
